<main class="vertical-center">
  <div class="main-content"> 
    <router-outlet></router-outlet>
  </div>
  <wtc-shared-messages></wtc-shared-messages>
</main>